"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-60fb9c68"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "maxContent" };
const _hoisted_2 = { class: "backContent" };
const _hoisted_3 = { class: "formContent" };
const _hoisted_4 = { style: { float: 'right' } };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "tableContent" };
const _hoisted_8 = { class: "selectInfo" };
const _hoisted_9 = {
    key: 0,
    class: "operation"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, null, -1));
const _hoisted_12 = ["onClick"];
const vue_router_1 = require("vue-router");
const vue_3 = require("vue");
const index_1 = require("../../service/index");
const ant_design_vue_1 = require("ant-design-vue");
const exportExcel_1 = require("../../utils/exportExcel");
const index_2 = require("../../utils/index");
const PAGESIZE = 10;
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const showMoreChoose = (0, vue_3.ref)(false);
        const tableData = (0, vue_3.ref)([]);
        const formRef = (0, vue_3.ref)();
        const queryCondition = (0, vue_3.ref)(Object.assign(Object.assign({}, history.state.params), { pageNum: 1, pageSize: PAGESIZE }));
        const router = (0, vue_router_1.useRouter)();
        const tableDataTotal = (0, vue_3.ref)();
        const currentPage = (0, vue_3.ref)(1);
        const selectRows = (0, vue_3.ref)([]);
        const [messageApi, contextHolder] = ant_design_vue_1.message.useMessage();
        const formOptions = (0, vue_3.ref)({});
        const formState = (0, vue_3.ref)({
            suyuanqijianwuliaobianma: '',
            lailiaopici: '',
            suyuanqijianwuliaomingcheng: '',
            chanpinsnma: '',
            chengpinsnma: '',
        });
        const onFormSelectSearch = (value, name) => __awaiter(this, void 0, void 0, function* () {
            const { suyuanqijianwuliaobianma, lailiaopici, suyuanqijianwuliaomingcheng, suyuanqijiansn, chengpinsnma } = formState.value;
            switch (name) {
                case "chengpinsnma": {
                    const response = yield (0, index_1.queryByCpSnKeywords)({
                        chengpinsnmaKeywords: (0, index_2.montageSN)(value),
                        lailiaopici: lailiaopici || undefined,
                        suyuanqijianwuliaobianma: suyuanqijianwuliaobianma || undefined,
                        suyuanqijianwuliaomingcheng: suyuanqijianwuliaomingcheng || undefined,
                        suyuanqijiansn: suyuanqijiansn || undefined,
                    });
                    formOptions.value.chengpinsnma = ((response === null || response === void 0 ? void 0 : response.data) || []).map((item) => ({
                        label: item,
                        value: item,
                    }));
                    break;
                }
                case "suyuanqijiansn": {
                    const response = yield (0, index_1.searchSnByKeywords)({
                        keywords: value,
                        lailiaopici: lailiaopici || undefined,
                        suyuanqijianwuliaobianma: suyuanqijianwuliaobianma || undefined,
                        suyuanqijianwuliaomingcheng: suyuanqijianwuliaomingcheng || undefined,
                        chengpinsnma: chengpinsnma || undefined,
                    });
                    formOptions.value.suyuanqijiansn = (response.data || []).map(item => (Object.assign({ label: item.suyuanqijiansn, value: item.suyuanqijiansn }, item)));
                    break;
                }
            }
        });
        const getTableData = (params) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const res = yield (0, index_1.syqjQueryByCondition)(params);
            tableData.value = (0, index_2.dataCleaning)((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.list.map((item, index) => (Object.assign(Object.assign({}, item), { id: currentPage.value + '-' + index }))), '--');
            tableDataTotal.value = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.total;
        });
        const markBadParts = (params) => __awaiter(this, void 0, void 0, function* () {
            if (params.suyuanqijiansn) {
                const res = yield (0, index_1.updateStatus)({
                    list: [
                        {
                            suyuanqijiansn: params.suyuanqijiansn,
                            status: 1
                        }
                    ]
                });
                if (res.data) {
                    messageApi.success('标记坏件成功');
                }
                else {
                    messageApi.error('标记坏件失败');
                }
            }
            else {
                messageApi.info('器件SN为空，无法标记');
            }
        });
        const onFinish = (values) => {
            selectedRowKeys.value = [];
            selectRows.value = [];
            for (const key in values) {
                if (!(values[key] || values[key] === 0)) {
                    delete values[key];
                }
            }
            if (Object.keys(values).length > 0) {
                queryCondition.value = values;
                getTableData(values);
            }
            else {
                messageApi.info('至少选择一项查询条件');
            }
        };
        const columns = [
            {
                title: '器件SN',
                dataIndex: 'suyuanqijiansn',
            },
            {
                title: '器件物料号',
                dataIndex: 'suyuanqijianwuliaobianma',
            },
            {
                title: '器件名称',
                dataIndex: 'suyuanqijianwuliaomingcheng',
            },
            {
                title: '供应商批次',
                dataIndex: 'lailiaopici',
            },
            {
                title: '所属桩SN',
                dataIndex: 'chengpinsnma',
            },
            {
                title: '桩的制令单',
                dataIndex: 'zhilingdan',
            },
            {
                title: '桩的生产线体',
                dataIndex: 'zhengzhuangshengchanxianti',
            },
            {
                title: '操作',
                dataIndex: 'address',
                key: 'operation',
                width: 150,
            },
        ];
        const selectedRowKeys = (0, vue_3.ref)([]);
        const onSelectChange = (changableRowKeys, selectedRows) => {
            selectedRowKeys.value = changableRowKeys;
            selectRows.value = selectedRows;
        };
        const rowSelection = (0, vue_3.computed)(() => {
            return {
                selectedRowKeys: (0, vue_3.unref)(selectedRowKeys),
                onChange: onSelectChange,
                hideDefaultSelections: true,
                columnWidth: 70,
                preserveSelectedRowKeys: true,
                selections: [
                    ant_design_vue_1.Table.SELECTION_INVERT,
                    ant_design_vue_1.Table.SELECTION_NONE,
                ],
            };
        });
        const markSelectBadParts = () => __awaiter(this, void 0, void 0, function* () {
            if (selectRows.value.length > 0) {
                let qjsnExist = true;
                for (let i = 0; i < selectRows.value.length; i++) {
                    if (!selectRows.value[i].suyuanqijiansn) {
                        qjsnExist = false;
                    }
                }
                if (qjsnExist) {
                    const list = selectRows.value.map((item) => {
                        return {
                            suyuanqijiansn: item.suyuanqijiansn,
                            status: 1
                        };
                    });
                    const res = yield (0, index_1.updateStatus)({ list });
                    if (res.data) {
                        messageApi.success('成功将勾选的溯源器件标记为坏件');
                    }
                }
                else {
                    messageApi.info('所选的数据中存在器件SN为空的数据，无法标记');
                }
            }
            else {
                messageApi.info('请先勾选需要标记为坏件的溯源器件！');
            }
        });
        const exportExcelByData = () => {
            if (selectRows.value.length > 0) {
                const headers = [{
                        headerName: '器件SN',
                        property: 'chanpinsnma'
                    }, {
                        headerName: '器件物料号',
                        property: 'suyuanqijianwuliaobianma'
                    }, {
                        headerName: '器件名称',
                        property: 'suyuanqijianwuliaomingcheng'
                    }, {
                        headerName: '供应商批次',
                        property: 'lailiaopici'
                    }, {
                        headerName: '所属桩SN',
                        property: 'chengpinsnma'
                    }, {
                        headerName: '桩的制令单',
                        property: 'zhilingdan'
                    }, {
                        headerName: '桩的生产线体',
                        property: 'zhengzhuangshengchanxianti'
                    }];
                (0, exportExcel_1.exportExcel)(selectRows.value, {
                    filename: '溯源器件信息表',
                    sheetName: '溯源器件信息',
                    headers
                });
            }
            else {
                messageApi.info('请先勾选需要导出的数据！');
            }
        };
        const toDeviceInfo = (record) => {
            router.push({
                path: '/deviceInfo',
                query: {
                    chengpinsnma: record.chengpinsnma === "--" || !record.chengpinsnma ? undefined : encodeURI(record.chengpinsnma),
                    suyuanqijiansn: (record.suyuanqijiansn === "--" || !record.suyuanqijiansn) ? undefined : encodeURI(record.suyuanqijiansn),
                    xuhao: record.xuhao == "--" || !record.xuhao ? undefined : encodeURI(record.xuhao),
                }
            });
        };
        const back = () => {
            router.back();
        };
        (0, vue_3.onMounted)(() => {
            var _a;
            getTableData(Object.assign(Object.assign({}, history.state.params), { pageNum: 1, pageSize: PAGESIZE }));
            formState.value = Object.assign(Object.assign(Object.assign({}, formState.value), history.state.params), { lailiaopici: (_a = history.state.params) === null || _a === void 0 ? void 0 : _a.pici });
        });
        return (_ctx, _cache) => {
            const _component_HeaderNew = (0, vue_2.resolveComponent)("HeaderNew");
            const _component_a_button = (0, vue_2.resolveComponent)("a-button");
            const _component_a_input = (0, vue_2.resolveComponent)("a-input");
            const _component_a_form_item = (0, vue_2.resolveComponent)("a-form-item");
            const _component_a_col = (0, vue_2.resolveComponent)("a-col");
            const _component_a_select = (0, vue_2.resolveComponent)("a-select");
            const _component_UpOutlined = (0, vue_2.resolveComponent)("UpOutlined");
            const _component_DownOutlined = (0, vue_2.resolveComponent)("DownOutlined");
            const _component_a_dropdown = (0, vue_2.resolveComponent)("a-dropdown");
            const _component_a_row = (0, vue_2.resolveComponent)("a-row");
            const _component_a_form = (0, vue_2.resolveComponent)("a-form");
            const _component_a_table = (0, vue_2.resolveComponent)("a-table");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_HeaderNew),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(_component_a_button, {
                        class: "back",
                        type: "primary",
                        onClick: back
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)("返回")
                        ]),
                        _: 1
                    })
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createVNode)(_component_a_form, {
                        model: formState.value,
                        name: "basic",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                        autocomplete: "off",
                        onFinish: onFinish,
                        ref_key: "formRef",
                        ref: formRef
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_a_row, { gutter: [8, 8] }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_a_col, {
                                        class: "gutter-row",
                                        span: 6
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_a_form_item, {
                                                label: "器件物料号",
                                                name: "suyuanqijianwuliaobianma"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_a_input, {
                                                        value: formState.value.suyuanqijianwuliaobianma,
                                                        "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((formState.value.suyuanqijianwuliaobianma) = $event)),
                                                        allowClear: ""
                                                    }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_a_col, {
                                        class: "gutter-row",
                                        span: 6
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_a_form_item, {
                                                label: "供应商批次",
                                                name: "lailiaopici"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_a_input, {
                                                        value: formState.value.lailiaopici,
                                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((formState.value.lailiaopici) = $event)),
                                                        allowClear: ""
                                                    }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_a_col, {
                                        class: "gutter-row",
                                        span: 6
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_a_form_item, {
                                                label: "器件名称",
                                                name: "suyuanqijianwuliaomingcheng"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_a_input, {
                                                        value: formState.value.suyuanqijianwuliaomingcheng,
                                                        "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((formState.value.suyuanqijianwuliaomingcheng) = $event)),
                                                        allowClear: ""
                                                    }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_a_col, {
                                        class: "gutter-row",
                                        span: 6
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_a_form_item, {
                                                label: "器件SN",
                                                name: "suyuanqijiansn"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_a_select, {
                                                        ref: "select",
                                                        value: formState.value.suyuanqijiansn,
                                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((formState.value.suyuanqijiansn) = $event)),
                                                        "show-search": "",
                                                        onSearch: _cache[4] || (_cache[4] = (value) => { onFormSelectSearch(value, 'suyuanqijiansn'); }),
                                                        options: formOptions.value.suyuanqijiansn,
                                                        allowClear: ""
                                                    }, null, 8, ["value", "options"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_a_col, {
                                        class: "gutter-row",
                                        span: 6
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_a_form_item, {
                                                label: "所属桩SN",
                                                name: "chengpinsnma"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_a_select, {
                                                        ref: "select",
                                                        value: formState.value.chengpinsnma,
                                                        "onUpdate:value": _cache[5] || (_cache[5] = ($event) => ((formState.value.chengpinsnma) = $event)),
                                                        "show-search": "",
                                                        onSearch: _cache[6] || (_cache[6] = (value) => { onFormSelectSearch(value, 'chengpinsnma'); }),
                                                        options: formOptions.value.chengpinsnma,
                                                        allowClear: ""
                                                    }, null, 8, ["value", "options"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 512), [
                                        [vue_2.vShow, showMoreChoose.value]
                                    ]),
                                    (0, vue_2.createVNode)(_component_a_col, {
                                        class: "gutter-row",
                                        span: 6,
                                        offset: showMoreChoose.value ? 12 : 18
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                                (0, vue_2.createVNode)(_component_a_button, {
                                                    type: "primary",
                                                    "html-type": "submit"
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)("查询")
                                                    ]),
                                                    _: 1
                                                }),
                                                (0, vue_2.createTextVNode)("     "),
                                                (0, vue_2.createVNode)(_component_a_button, {
                                                    type: "primary",
                                                    onClick: _cache[7] || (_cache[7] = ($event) => (formRef.value.resetFields()))
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)("重置")
                                                    ]),
                                                    _: 1
                                                }),
                                                (0, vue_2.createTextVNode)("     "),
                                                (0, vue_2.createVNode)(_component_a_dropdown, null, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createElementVNode)("a", {
                                                            class: "ant-dropdown-link",
                                                            onClick: _cache[8] || (_cache[8] = ($event) => (showMoreChoose.value = !showMoreChoose.value))
                                                        }, [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(showMoreChoose.value ? '收起' : '展开') + " ", 1),
                                                            (showMoreChoose.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_5, [
                                                                    (0, vue_2.createVNode)(_component_UpOutlined)
                                                                ]))
                                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, [
                                                                    (0, vue_2.createVNode)(_component_DownOutlined)
                                                                ]))
                                                        ])
                                                    ]),
                                                    _: 1
                                                })
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["offset"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["model"])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createTextVNode)(" 已选中 " + (0, vue_2.toDisplayString)(selectedRowKeys.value.length) + " 条数据 ", 1),
                        (0, vue_2.createVNode)(_component_a_button, {
                            class: "export",
                            type: "primary",
                            onClick: exportExcelByData
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)("一键导出")
                            ]),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(_component_a_button, {
                            class: "mark",
                            type: "primary",
                            onClick: markSelectBadParts
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)("一键标记坏件")
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createVNode)(_component_a_table, {
                        rowKey: (record) => record.id,
                        "row-selection": rowSelection.value,
                        columns: columns,
                        "data-source": tableData.value,
                        pagination: {
                            pageSize: PAGESIZE,
                            total: tableDataTotal.value,
                            onChange: (page) => {
                                currentPage.value = page;
                                getTableData(Object.assign(Object.assign({}, queryCondition.value), { pageNum: page, pageSize: PAGESIZE }));
                            }
                        }
                    }, {
                        bodyCell: (0, vue_2.withCtx)(({ column, record }) => [
                            (column.key === 'operation')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                    (0, vue_2.createElementVNode)("span", {
                                        onClick: () => { toDeviceInfo(record); }
                                    }, "详情", 8, _hoisted_10),
                                    _hoisted_11,
                                    (0, vue_2.createElementVNode)("span", {
                                        onClick: ($event) => (markBadParts(record))
                                    }, "标记坏件", 8, _hoisted_12)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        _: 1
                    }, 8, ["rowKey", "row-selection", "data-source", "pagination"])
                ]),
                (0, vue_2.createVNode)((0, vue_2.unref)(contextHolder))
            ]));
        };
    }
});
